// Mappa Province Italiane → Zone Mobility Safe
// Zone: 1, 2, 3, 4, 3bis

export const provinceZoneMap = {
  // Zona 2
  "MB": "2", // Monza Brianza
  "CA": "2", // Cagliari
  "FI": "2", // Firenze
  "CH": "2", // Chieti
  "PE": "2", // Pescara
  "PZ": "2", // Potenza
  "CS": "2", // Cosenza
  "CZ": "2", // Catanzaro
  "CB": "2", // Campobasso
  "IS": "2", // Isernia
  "AG": "2", // Agrigento
  "CL": "2", // Caltanissetta
  "EN": "2", // Enna
  "ME": "2", // Messina
  "PA": "2", // Palermo
  "RG": "2", // Ragusa
  "SR": "2", // Siracusa
  
  // Zona 3 (alcune richiedono distinzione città/provincia)
  "GE": "3", // Genova
  "SA": "3", // Salerno
  "PO": "3", // Prato
  "MT": "3", // Matera
  "VV": "3", // Vibo Valentia
  "AV": "3", // Avellino
  "BN": "3", // Benevento
  "LT": "3", // Latina
  "LE": "3", // Lecce
  "CT": "3", // Catania
  
  // Zona 3 con distinzione città/provincia
  "MI": "3", // Milano - città zona 3, provincia zona 3
  "RM": "3", // Roma - città zona 3, provincia zona 3
  
  // Zona 4
  "RC": "4", // Reggio Calabria
  "KR": "4", // Crotone
  "CE": "4", // Caserta
  "NA": "4", // Napoli
  "BA": "4", // Bari
  "BR": "4", // Brindisi
  "BT": "4", // Barletta-Andria-Trani
  "FG": "4", // Foggia
  "TA": "4", // Taranto
  
  // Zona 3bis
  "TO": "3bis" // Torino - città e provincia
};

// Province che richiedono distinzione città/provincia per zona 3
export const cityProvinceDistinction = {
  "MI": { city: "3", province: "3" },
  "RM": { city: "3", province: "3" }
};

// Lista completa province italiane per autocomplete
export const italianProvinces = [
  { code: "AG", name: "Agrigento", region: "Sicilia" },
  { code: "AL", name: "Alessandria", region: "Piemonte" },
  { code: "AN", name: "Ancona", region: "Marche" },
  { code: "AO", name: "Aosta", region: "Valle d'Aosta" },
  { code: "AR", name: "Arezzo", region: "Toscana" },
  { code: "AP", name: "Ascoli Piceno", region: "Marche" },
  { code: "AT", name: "Asti", region: "Piemonte" },
  { code: "AV", name: "Avellino", region: "Campania" },
  { code: "BA", name: "Bari", region: "Puglia" },
  { code: "BT", name: "Barletta-Andria-Trani", region: "Puglia" },
  { code: "BL", name: "Belluno", region: "Veneto" },
  { code: "BN", name: "Benevento", region: "Campania" },
  { code: "BG", name: "Bergamo", region: "Lombardia" },
  { code: "BI", name: "Biella", region: "Piemonte" },
  { code: "BO", name: "Bologna", region: "Emilia-Romagna" },
  { code: "BZ", name: "Bolzano", region: "Trentino-Alto Adige" },
  { code: "BS", name: "Brescia", region: "Lombardia" },
  { code: "BR", name: "Brindisi", region: "Puglia" },
  { code: "CA", name: "Cagliari", region: "Sardegna" },
  { code: "CL", name: "Caltanissetta", region: "Sicilia" },
  { code: "CB", name: "Campobasso", region: "Molise" },
  { code: "CE", name: "Caserta", region: "Campania" },
  { code: "CT", name: "Catania", region: "Sicilia" },
  { code: "CZ", name: "Catanzaro", region: "Calabria" },
  { code: "CH", name: "Chieti", region: "Abruzzo" },
  { code: "CO", name: "Como", region: "Lombardia" },
  { code: "CS", name: "Cosenza", region: "Calabria" },
  { code: "CR", name: "Cremona", region: "Lombardia" },
  { code: "KR", name: "Crotone", region: "Calabria" },
  { code: "CN", name: "Cuneo", region: "Piemonte" },
  { code: "EN", name: "Enna", region: "Sicilia" },
  { code: "FM", name: "Fermo", region: "Marche" },
  { code: "FE", name: "Ferrara", region: "Emilia-Romagna" },
  { code: "FI", name: "Firenze", region: "Toscana" },
  { code: "FG", name: "Foggia", region: "Puglia" },
  { code: "FC", name: "Forlì-Cesena", region: "Emilia-Romagna" },
  { code: "FR", name: "Frosinone", region: "Lazio" },
  { code: "GE", name: "Genova", region: "Liguria" },
  { code: "GO", name: "Gorizia", region: "Friuli-Venezia Giulia" },
  { code: "GR", name: "Grosseto", region: "Toscana" },
  { code: "IM", name: "Imperia", region: "Liguria" },
  { code: "IS", name: "Isernia", region: "Molise" },
  { code: "SP", name: "La Spezia", region: "Liguria" },
  { code: "AQ", name: "L'Aquila", region: "Abruzzo" },
  { code: "LT", name: "Latina", region: "Lazio" },
  { code: "LE", name: "Lecce", region: "Puglia" },
  { code: "LC", name: "Lecco", region: "Lombardia" },
  { code: "LI", name: "Livorno", region: "Toscana" },
  { code: "LO", name: "Lodi", region: "Lombardia" },
  { code: "LU", name: "Lucca", region: "Toscana" },
  { code: "MC", name: "Macerata", region: "Marche" },
  { code: "MN", name: "Mantova", region: "Lombardia" },
  { code: "MS", name: "Massa-Carrara", region: "Toscana" },
  { code: "MT", name: "Matera", region: "Basilicata" },
  { code: "ME", name: "Messina", region: "Sicilia" },
  { code: "MI", name: "Milano", region: "Lombardia" },
  { code: "MO", name: "Modena", region: "Emilia-Romagna" },
  { code: "MB", name: "Monza e Brianza", region: "Lombardia" },
  { code: "NA", name: "Napoli", region: "Campania" },
  { code: "NO", name: "Novara", region: "Piemonte" },
  { code: "NU", name: "Nuoro", region: "Sardegna" },
  { code: "OR", name: "Oristano", region: "Sardegna" },
  { code: "PD", name: "Padova", region: "Veneto" },
  { code: "PA", name: "Palermo", region: "Sicilia" },
  { code: "PR", name: "Parma", region: "Emilia-Romagna" },
  { code: "PV", name: "Pavia", region: "Lombardia" },
  { code: "PG", name: "Perugia", region: "Umbria" },
  { code: "PU", name: "Pesaro e Urbino", region: "Marche" },
  { code: "PE", name: "Pescara", region: "Abruzzo" },
  { code: "PC", name: "Piacenza", region: "Emilia-Romagna" },
  { code: "PI", name: "Pisa", region: "Toscana" },
  { code: "PT", name: "Pistoia", region: "Toscana" },
  { code: "PN", name: "Pordenone", region: "Friuli-Venezia Giulia" },
  { code: "PZ", name: "Potenza", region: "Basilicata" },
  { code: "PO", name: "Prato", region: "Toscana" },
  { code: "RG", name: "Ragusa", region: "Sicilia" },
  { code: "RA", name: "Ravenna", region: "Emilia-Romagna" },
  { code: "RC", name: "Reggio Calabria", region: "Calabria" },
  { code: "RE", name: "Reggio Emilia", region: "Emilia-Romagna" },
  { code: "RI", name: "Rieti", region: "Lazio" },
  { code: "RN", name: "Rimini", region: "Emilia-Romagna" },
  { code: "RM", name: "Roma", region: "Lazio" },
  { code: "RO", name: "Rovigo", region: "Veneto" },
  { code: "SA", name: "Salerno", region: "Campania" },
  { code: "SS", name: "Sassari", region: "Sardegna" },
  { code: "SV", name: "Savona", region: "Liguria" },
  { code: "SI", name: "Siena", region: "Toscana" },
  { code: "SO", name: "Sondrio", region: "Lombardia" },
  { code: "SU", name: "Sud Sardegna", region: "Sardegna" },
  { code: "SR", name: "Siracusa", region: "Sicilia" },
  { code: "TA", name: "Taranto", region: "Puglia" },
  { code: "TE", name: "Teramo", region: "Abruzzo" },
  { code: "TR", name: "Terni", region: "Umbria" },
  { code: "TO", name: "Torino", region: "Piemonte" },
  { code: "TP", name: "Trapani", region: "Sicilia" },
  { code: "TN", name: "Trento", region: "Trentino-Alto Adige" },
  { code: "TV", name: "Treviso", region: "Veneto" },
  { code: "TS", name: "Trieste", region: "Friuli-Venezia Giulia" },
  { code: "UD", name: "Udine", region: "Friuli-Venezia Giulia" },
  { code: "VA", name: "Varese", region: "Lombardia" },
  { code: "VE", name: "Venezia", region: "Veneto" },
  { code: "VB", name: "Verbano-Cusio-Ossola", region: "Piemonte" },
  { code: "VC", name: "Vercelli", region: "Piemonte" },
  { code: "VR", name: "Verona", region: "Veneto" },
  { code: "VV", name: "Vibo Valentia", region: "Calabria" },
  { code: "VI", name: "Vicenza", region: "Veneto" },
  { code: "VT", name: "Viterbo", region: "Lazio" }
];

// Risolve la zona data una provincia
export const resolveZone = (provinceCode, isCapoluogo = false) => {
  if (!provinceCode) return "1"; // Fallback zona 1
  
  const code = provinceCode.toUpperCase();
  
  // Verifica se la provincia ha distinzione città/provincia
  if (cityProvinceDistinction[code]) {
    return isCapoluogo 
      ? cityProvinceDistinction[code].city 
      : cityProvinceDistinction[code].province;
  }
  
  // Cerca nella mappa standard
  const zone = provinceZoneMap[code];
  return zone || "1"; // Fallback zona 1 se non trovata
};

// Ottieni nome zona per display
export const getZoneDisplayName = (zone) => {
  const zoneNames = {
    "1": "Zona 1",
    "2": "Zona 2", 
    "3": "Zona 3",
    "4": "Zona 4",
    "3bis": "Zona 3bis"
  };
  return zoneNames[zone] || "Zona 1";
};